var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 14.8611V10.25H14.8611V14.8611H10.25Z",
    stroke: "#141233",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 23.75V19.1389H14.8611V23.75H10.25Z",
    stroke: "#141233",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1387 14.8611V10.25H23.7498V14.8611H19.1387Z",
    stroke: "#141233",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.5C18 18.2239 18.2239 18 18.5 18H19.8362C20.1124 18 20.3363 18.2239 20.3363 18.5V20.3363H18.5C18.2239 20.3363 18 20.1124 18 19.8363V18.5Z",
    fill: "#141233"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24.5C18 24.7761 18.2239 25 18.5 25H19.8362C20.1124 25 20.3363 24.7761 20.3363 24.5V22.6637H18.5C18.2239 22.6637 18 22.8876 18 23.1637V24.5Z",
    fill: "#141233"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.5C25 18.2239 24.7761 18 24.5 18H23.1638C22.8876 18 22.6637 18.2239 22.6637 18.5V20.3363H24.5C24.7761 20.3363 25 20.1124 25 19.8363V18.5Z",
    fill: "#141233"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.5C25 24.7761 24.7761 25 24.5 25H23.1638C22.8876 25 22.6637 24.7761 22.6637 24.5V22.6637H24.5C24.7761 22.6637 25 22.8876 25 23.1637V24.5Z",
    fill: "#141233"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.332,
    y: 20.3319,
    width: 2.33625,
    height: 2.33625,
    fill: "#141233"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.94529e47.svg";
export { ForwardRef as ReactComponent };